import { G } from '@mobily/ts-belt';

import type { B2bCampaignType } from '@Common/types/bo/b2b/campaigns';

export const B2bCampaignTypePersonalAssetsGroup: readonly B2bCampaignType[] = [
  'voluntary_deposit',
  'unused_vacation_days',
];

/**
 * VVE and CET campaign *deposit* amounts are exempt from CSG/CRDS.
 *
 * Scope: the deposit only. Employer matching contribution stays taxed on these campaigns — see
 * `scripts/b2b/backfill_vve_cet_csg_crds_exemption`, which corrects deposit taxes while leaving MC
 * untouched, and the CET spec ("treated as a standard employer contribution").
 *
 */
export function isExemptFromCsgCrdsCampaign(type: B2bCampaignType | null | undefined): boolean {
  return G.isNotNullable(type) && B2bCampaignTypePersonalAssetsGroup.includes(type);
}
